// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".named-input__name{align-items:flex-end;display:flex;justify-content:space-between;margin:0 2px}.named-input__name label{color:#666;font-size:1rem;margin-bottom:3px}.named-input__name label .required-marker{color:#e2001a}.named-input__name .hint{color:#999;font-size:.875rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
